import React from "react";
import { Heading, Subheading } from "../../design/heading";
import { Table, TableBody, TableCell, TableRow } from "../../design/table";
import CreateMatterTypeButton from "./components/CreateMatterTypeButton";
import { useMatterType } from "../../contexts/MatterTypeContext";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import { Text } from "../../design/text";
import EmptyStateView from "../../components/EmptyStateView";
import { Avatar } from "../../design/avatar";
import { PlusIcon } from "@heroicons/react/20/solid";

const MatterTypeListPage: React.FC = () => {
  const { matterTypes, error, loading } = useMatterType();

  if (loading.list) {
    return <LoadingView title="Loading Matter Types" />;
  }
  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-end justify-between gap-4">
        <div className="flex flex-col gap-2">
          <Heading>Matter Types</Heading>
        </div>
        <div className="flex gap-4">
          <CreateMatterTypeButton />
        </div>
      </div>
      {matterTypes.length === 0 && (
        <EmptyStateView
          title="No Matter Types"
          message="You have not created any matter types yet."
          action={
            <CreateMatterTypeButton>Create Matter Type</CreateMatterTypeButton>
          }
          className="h-full"
        />
      )}
      {matterTypes.length > 0 && (
        <Table>
          <TableBody>
            {matterTypes.map((matterType) => (
              <TableRow
                key={matterType._id}
                href={`/matter-type/${matterType._id}`}
              >
                <TableCell>
                  <div className="flex items-center gap-4">
                    {matterType.photoUrl && (
                      <Avatar
                        src={matterType.photoUrl}
                        alt={matterType.name}
                        className="w-16 h-16 rounded-full"
                      />
                    )}
                    <div className="flex flex-col gap-2">
                      <Subheading>{matterType.name}</Subheading>
                      {matterType.description && (
                        <Text className="whitespace-pre-line line-clamp-2">
                          {matterType.description}
                        </Text>
                      )}
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default MatterTypeListPage;
